// extracted by mini-css-extract-plugin
var _1 = "PrefixInputBackground-module__container--UH0YO";
export { _1 as "container" }
